import { learnflowStats, saveflowPlusLearnflowStats, saveflowStats } from './featuresChart';
import { flexflowChartData } from './flexflowChartData';
import { type ChartsTypeProps } from './types';
import { usageChartData } from './usageChart';

export const charts = (props: ChartsTypeProps) => {
  const { theme } = props;

  return {
    usageChart: usageChartData(theme),
    saveLearnFlowChart: saveflowPlusLearnflowStats(theme),
    flexflowChart: flexflowChartData(theme),
    learnflowStats: learnflowStats(theme),
    saveflowStats: saveflowStats(theme)
  };
};
